import api from '../api';
let apiUrl = 'meta';

const state = {
    data: {},
    length: 0
};

const actions = {
    index: async ({ commit }, config) => {
        return await api
            .get(`/api/v1/${apiUrl}`, config)
            .then((response) => {
                commit('set', response);
                return response;
            })
            .catch((error) => {
                console.error(error);
                return Promise.reject(error);
            });
    }
};

const mutations = {
    set(state, response) {
        state.data = response.data;
        state.length = response.data.length;
    }
};

const getters = {
    get: (state) => {
        return state;
    }
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
};
